export var TicketSessionStatus;
(function (TicketSessionStatus) {
    TicketSessionStatus[TicketSessionStatus["INACTIVE"] = 10] = "INACTIVE";
    TicketSessionStatus[TicketSessionStatus["ACTIVE"] = 20] = "ACTIVE";
})(TicketSessionStatus || (TicketSessionStatus = {}));
//# sourceMappingURL=ticket-session-status.enum.js.map